import { render } from "./ListFarmacias.vue?vue&type=template&id=13770f26"
import script from "./ListFarmacias.vue?vue&type=script&lang=js"
export * from "./ListFarmacias.vue?vue&type=script&lang=js"

import "./ListFarmacias.vue?vue&type=style&index=0&id=13770f26&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__